import { render, staticRenderFns } from "./follow-button.vue?vue&type=template&id=38a7c022&scoped=true&"
import script from "./follow-button.vue?vue&type=script&lang=js&"
export * from "./follow-button.vue?vue&type=script&lang=js&"
import style0 from "./follow-button.vue?vue&type=style&index=0&id=38a7c022&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a7c022",
  null
  
)

export default component.exports